webpackJsonp([267184552703591],{

/***/ 1125:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0012_reversal.jpg","type":"Spell","subtype":"Debuff","cost":3,"ATK":null,"HP":null,"rules_text_1":"Deal 3 damage to a patroller, then disable it. (Exhaust it and it doesn't ready during its next ready step. Sideline it if it was patrolling.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Reversal","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"White","spec":"Discipline","bottom":"Magic","rulings":[],"keywords":[],"slug":"reversal"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"reversal","keywords":[],"imageRegex":"/reversal.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-reversal-e17227a7a9b45f19c7af.js